module.exports = __webpack_public_path__ + "Roboto-Regular.ba3dcd8903e3d0af5de7.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Regular.woff
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Regular.woff
// module chunks = 3